import { Stack } from '@mui/material'
import { StyledPageNav } from './pageNav.styles'
import HeaderLink from '@biolumina/ui/components/header/components/headerLink'
import { usePageData } from '@biolumina/ui/hooks/pageData.hook'
import {
  ArrowIcon,
  ArrowIconLeft,
} from '@biolumina/ui/components/icons/arrowIcon'

export const PageNav = () => {
  const { prev, next } = usePageData()

  return (
    <StyledPageNav className="page-wrapper">
      <Stack
        direction="row"
        justifyContent="space-between"
        className="content-wrapper"
      >
        {prev ? (
          <HeaderLink
            className="prev"
            iconSide="left"
            icon={ArrowIconLeft}
            data-tracking="body-utility-nav-item"
            {...prev}
          />
        ) : (
          <span />
        )}
        {next ? (
          <HeaderLink
            className="next"
            icon={ArrowIcon}
            data-tracking="body-utility-nav-item"
            {...next}
          />
        ) : (
          <span />
        )}
      </Stack>
    </StyledPageNav>
  )
}
